﻿import { initPopupContainer, closePopup } from "./_menu";

function attachDropdownMenu(button, menu) {
	const container = initPopupContainer();
	container.append(menu);
	menu.popperInstance?.update();
}

function destroyDropdownMenu(button/*, options*/) {
	const dropdownId = button.getAttribute("aria-controls");
	const dropdown = dropdownId && document.getElementById(dropdownId);
	if (dropdown && !dropdown.matches(":focus-within")) {
		closePopup(dropdown);
	}
}

function toggleDropdownMenu(trigger, menu) {
	if (trigger.getAttribute("aria-expanded") === "true") {
		destroyDropdownMenu(trigger, menu);
	} else if (!document.getElementById(trigger.getAttribute("aria-controls"))) {
		attachDropdownMenu(trigger, menu);
	}
}

function init(context, selector = "#td-usermenu") {
	const trigger = (context || document).querySelector(selector);
	const menu = (context || document).querySelector(selector + "popup");
	if (trigger && menu) {
		menu.remove();
		trigger.addEventListener("focus", ({ target }) => attachDropdownMenu(target, menu));
		trigger.addEventListener("click", ({ target }) => toggleDropdownMenu(target, menu));
		trigger.addEventListener("v3-popup.close", ({ detail: menu }) => {
			menu.remove();
		});
	}
}

export { init };